import { inject, Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { FilterSelectItem } from '../../../components/checkbox-facette/checkbox-liste/filterSelectItem';
import { AggregationKey } from '../../../model/aggregations';
import {
  orderedWeiterbildungsarten,
  orderedWeiterbildungsartenUteAngebote,
  orderedWeiterbildungsartenWeiterbildungsangebote
} from '../../../model/weiterbildungsarten';
import { BildungsbereichService } from '../../state/bildungsbereich.service';
import { FacettenService } from '../facetten.service';
import { WeiterbildungsartUrlService } from './weiterbildungsarturl.service';

@Injectable({ providedIn: 'root' })
export class WeiterbildungsartService extends FacettenService {
  private readonly bildungsbereichService = inject(BildungsbereichService);

  constructor() {
    const weiterbildungsartServiceUrlService = inject(WeiterbildungsartUrlService);

    super(
      weiterbildungsartServiceUrlService,
      AggregationKey.Weiterbildungsart,
      orderedWeiterbildungsarten
    );
  }

  public override getSelectItems$(): Observable<FilterSelectItem[]> {
    return combineLatest([
      this.getFacetteOptions$(),
      this.facettenUrlService.selectedOptionIds$,
      this.bildungsbereichService.isUte$
    ]).pipe(
      map(([facetteOptions, ids, isUte]) => {
        const options = isUte
          ? orderedWeiterbildungsartenUteAngebote
          : orderedWeiterbildungsartenWeiterbildungsangebote;
        return options.map(({ id, bezeichnung, modal, backendId }) => {
          const anzahl =
            facetteOptions.find((option) => option.id === backendId.toString())?.anzahl ?? 0;
          const isSelected = this.isItemSelected(ids, backendId.toString());
          const item = {
            key: id.toString(),
            ariaLabel: bezeichnung,
            treffer: anzahl,
            label: bezeichnung,
            selected: isSelected,
            active: anzahl > 0,
            modal
          };
          return item;
        });
      })
    );
  }
}
